interface ElementWithGroupRef {
    uuid?: string | null;
    groupId?: string | number | null;
    [key: string]: any;
}

interface PreviewStep2Collections {
    texts?: ElementWithGroupRef[];
    circularTexts?: ElementWithGroupRef[];
    imagePlaceHolders?: ElementWithGroupRef[];
    vectorsEps?: ElementWithGroupRef[];
}

export type ResolveLoadedElementGroupId = (element: ElementWithGroupRef) => string | number | undefined;

function resolveCollectionGroupIds(
    collection: ElementWithGroupRef[] | undefined,
    resolveLoadedElementGroupId: ResolveLoadedElementGroupId
): ElementWithGroupRef[] | undefined {
    if (!collection) {
        return collection;
    }

    return collection.map((element) => ({
        ...element,
        groupId: resolveLoadedElementGroupId(element)
    }));
}

/**
 * Applies Step 2 groupId resolution to every preview element collection that is loaded
 * from persistence (texts, circular texts, image placeholders and vectors).
 */
export function resolvePreviewStep2GroupIds(
    collections: PreviewStep2Collections,
    resolveLoadedElementGroupId: ResolveLoadedElementGroupId
): PreviewStep2Collections {
    return {
        texts: resolveCollectionGroupIds(collections.texts, resolveLoadedElementGroupId),
        circularTexts: resolveCollectionGroupIds(collections.circularTexts, resolveLoadedElementGroupId),
        imagePlaceHolders: resolveCollectionGroupIds(collections.imagePlaceHolders, resolveLoadedElementGroupId),
        vectorsEps: resolveCollectionGroupIds(collections.vectorsEps, resolveLoadedElementGroupId)
    };
}
